'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _AppConfigContainer = require('../globals/AppConfigContainer');

var _AppConfigContainer2 = _interopRequireDefault(_AppConfigContainer);

var _PortalIdContainer = require('../globals/PortalIdContainer');

var _PortalIdContainer2 = _interopRequireDefault(_PortalIdContainer);

var _envInfo = require('../constants/envInfo');

var _Config = require('../selectors/Config');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

exports.default = function (StepHandler) {
  var _class, _temp;

  var StepProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return _temp = _class = function (_React$Component) {
    _inherits(StepHandlerWrapper, _React$Component);

    function StepHandlerWrapper() {
      _classCallCheck(this, StepHandlerWrapper);

      return _possibleConstructorReturn(this, (StepHandlerWrapper.__proto__ || Object.getPrototypeOf(StepHandlerWrapper)).apply(this, arguments));
    }

    _createClass(StepHandlerWrapper, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        // history.onChange tends to double-fire the events so it isn't reliable.
        // I'll move this somewhere else when there is a better solution.
        var portalIdToSet = this.props.params.portalId;
        var portalId = _PortalIdContainer2.default.get();
        var routeName = window.location.pathname;

        // Attempt to stash the portal id
        if (!portalId && portalIdToSet) {
          portalId = portalIdToSet;
          _PortalIdContainer2.default.set(portalIdToSet);
        }

        // GA tracking - omits portalId (e.g. /signup/sales/bridge)
        if (portalId) {
          routeName = routeName.replace('/' + portalId, '');
        }
        if (window.hasOwnProperty('ga') && _envInfo.isProd) {
          window.ga('send', 'pageview', routeName);
        }
      }
    }, {
      key: 'render',
      value: function render() {
        var _props = this.props,
            stepKey = _props.stepKey,
            params = _props.params,
            location = _props.location,
            routes = _props.routes;


        return _react2.default.createElement(
          'div',
          {
            className: (0, _classnames2.default)('step-' + stepKey, {
              'step-sidebar': _AppConfigContainer2.default.get('hasSidebar'),
              'step-embedded': (0, _Config.getIsEmbeddedContentFlow)()
            })
          },
          _react2.default.createElement(StepHandler, _extends({
            params: params,
            routes: routes,
            location: location
          }, StepProps))
        );
      }
    }]);

    return StepHandlerWrapper;
  }(_react2.default.Component), _class.propTypes = {
    stepKey: _propTypes2.default.string.isRequired,
    location: _propTypes2.default.object.isRequired,
    params: _propTypes2.default.object.isRequired,
    routes: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.array]).isRequired
  }, _temp;
};

module.exports = exports['default'];